import AppService from './AppService';

class PaymentService extends AppService {

  constructor() {
    super();
    this.path = this.getPath('payments');
  }
  list(dateFilter ='') {
    this.http.defaults.params = {
      'date': dateFilter
    }
    return this.http.get(`${this.path}`);
  }
  listPaymentRecords(id) {
    return this.http.get(`${this.path}/${id}`);
  }
  download(path){
    this.http.responseType = 'blob';
    this.http.defaults.params = {
      'name': path
    }
    return this.http.get(`${this.path}/download`);
  }
  upload(data) {
    return this.http.post(`${this.path}/upload`, data);
  }
  delete(data){
    return this.http.patch(`${this.path}/delete-payment`, data);
  }
}

export default PaymentService;
